import PropTypes from '@root/vendor/prop-types';
import Spacer from '@root/joinroot.com/src/components/spacer';

export default function SpacerBlock({ content }) {
  const height = parseInt(content.spacerHeight);

  return (
    <div data-testid={'spacerBlock'}>
      <Spacer
        backgroundColor={content.backgroundColor}
        height={height}
      />
    </div>
  );
}

SpacerBlock.propTypes = {
  content: PropTypes.shape({
    backgroundColor: PropTypes.string,
    spacerHeight: PropTypes.string,
  }).isRequired,
};

